import React, { useState } from "react";
import { Link } from "react-router-dom";
import Api from "../service/Api";

import Logo from "../../public/assets/img/blue_logo.png";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter your email.");
      return;
    }
    try {
      await Api.subscribe({ email });
      setMessage("You have successfully subscribed to our newsletter.");
      setEmail("");
    } catch (err) {
      console.error(err);
      setMessage(
        "There was an error subscribing to our newsletter. Please try again.",
      );
    }
  };

  return (
    <footer id="footer" className="footer">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <Link
              to="/"
              className="footer-logo d-flex justify-content-left align-items-left"
            >
              <img
                src={Logo}
                alt="Lubrichem Oils Pvt Ltd."
                className="img-fluid"
              />
            </Link>

            <div className="footer-contact pt-3">
              <p>
                We’re a team of strategic creator and digital innovator, united
                focus in our pursuit of mastery and joyful.
              </p>
              <p>
                <strong>Phone:</strong>+91 9881470186
              </p>
              <p>
                <strong>Email:</strong>sales@lubrichem.co.in
              </p>
              <p>
                <strong>Address:</strong> S.No.37/1, Pisoli Road, Kondhwa Pune -
                411048, Maharashtra, India
              </p>
            </div>
            <div className="social-links d-flex">
              {/* <a href="">
                <i className="bi bi-twitter-x"></i>
              </a> */}
              <a
                href="https://www.facebook.com/share/1Au2kKMfw9/"
                target="_blank"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/lubrichem_?igsh=MXAyYXJ3OG83amljeA=="
                target="_blank"
              >
                <i className="bi bi-instagram"></i>
              </a>
              {/* <a href="">
                <i className="bi bi-linkedin"></i>
              </a> */}
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Pages</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right"></i> <Link to="/">Home</Link>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <Link to="/about-us">About us</Link>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>{" "}
                <Link to="/products">Products</Link>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>
                <a href="#">Our Clients</a>
              </li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Utility Pages</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right"></i>
                <Link to="/privacy-policy">Privacy policy</Link>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <i className="bi bi-chevron-right"></i>
                <Link to="/cookies-policy">Cookies policy</Link>
              </li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12">
            <h4>Join Our Newsletter</h4>
            <p>
              Subscribe to our newsletter and receive the latest news about our
              products and services!
            </p>
            <form onSubmit={handleSubscribe}>
              <div className="newsletter-form">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  required
                />
                <input type="submit" value="Subscribe" />
              </div>
            </form>
            {message && <p className="mt-2">{message}</p>}
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>
          <strong className="px-1 sitename">Lubrichem</strong>
          <span>All Rights Reserved</span>
        </p>
        <div className="credits">
          Designed by <a href="#">Verheffen Info-Tech</a>
        </div>
      </div>
    </footer>
  );
}
